// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

export const XngPopulateApiParameter: any = (props: any) => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }
    props.apiParameter = {
        cartLines: order.value.orderLines!.map(
            (line: OrderLineModel) =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                    // XNG-Changes: passing nonStockItems data
                    properties: {
                        nonStockProductDescription: line.properties.nonStockProductDescription,
                        nonStockProductErpNumber: line.properties.nonStockProductErpNumber,
                    },
                } as any),
        ),
    } as CartLineCollectionModel;
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
